import { z } from "zod";
import { feedbackDtoSchema } from "./order.js";

/**
 * A rating in the context of the response that earned it.
 *
 * `FeedbackDto` (the conversation-detail embed) can stay bare because the
 * transcript is already on screen beside it. The Feedback *page* has no such
 * context, and "Rated unhelpful" on its own tells a client nothing they can
 * act on — so the list carries the exchange with it.
 *
 * What it deliberately does not carry is prompt text. This route is
 * membership-gated, not `platform_admin`-gated, so a suggestion appears here
 * as an id and a status only; the revision, the diff and the agent's traces
 * come from the platform-admin routes or not at all.
 */
export const feedbackSuggestionRefSchema = z.object({
  id: z.string().uuid(),
  status: z.enum(["running", "ready", "failed", "applied", "rejected"]),
});
export type FeedbackSuggestionRef = z.infer<typeof feedbackSuggestionRefSchema>;

export const feedbackEntryDtoSchema = feedbackDtoSchema.extend({
  botId: z.string().uuid().nullable(),
  botName: z.string().nullable(),
  /** The assistant reply that was rated. Null when the rating was for the conversation as a whole, or when the message has since been purged. */
  ratedReply: z.string().nullable(),
  /** The visitor turn immediately before that reply — the question it was answering, which is what makes a bad answer legible. */
  precedingUserMessage: z.string().nullable(),
  suggestion: feedbackSuggestionRefSchema.nullable(),
});
export type FeedbackEntryDto = z.infer<typeof feedbackEntryDtoSchema>;
